module.exports = __webpack_public_path__ + "assets/icons/jobstab-bid.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/tabs/jobstab-bid.png
// module id = ./src/styles/icons/tabs/jobstab-bid.png
// module chunks = 0